<template>
    <div>

        
        <store-special-index v-show="special && special['store/index'+store.store_id]" :page-path="'store/index'" :item-id="''" v-if="store.store_name != ''" :store="store"></store-special-index>
        <div class="container" v-show="!special || !special['store/index'+store.store_id]">
			<common-store-header v-if="showStoreSpecial.showSpecialHeader==1" :store="store"></common-store-header>
            <!--直播start-->
            <div class="live-wrapper"  v-if="store.live_apply_info" @click="goLive(store.live_apply_info.live_apply_id)">
                <div class="box-wrapper v live-back-wrapper">
                    <img :src="store.live_apply_info.live_apply_cover_image_url" class="live-back-image" />
                    <div class="box-wrapper v live-back-cover"></div>
                </div>
                <div class="live-title">{{store.live_apply_info.live_apply_name}}</div>
                <div class="box-wrapper h" style="align-items: flex-end">
                    <div class="box-wrapper v left">
                        <div class="box-wrapper v live-image">
                            <video v-if="store.live_apply_info.live_apply_cover_video" :src="store.live_apply_info.live_apply_cover_video_url" muted="muted" autoplay="autoplay" loop="loop" />
                            <img v-else :src="store.live_apply_info.live_apply_cover_image_url">
                        </div>
                    </div>
                    <div class="box-wrapper v right">
                        <div class="box-wrapper v live-info">

                            <div class="box-wrapper v live-desc">
                                <span class="live-count">{{store.live_apply_info.live_apply_view_count}}次观看</span>
                                <img src="../../../assets/image/live/live-state.png" class="live-icon" />
                            </div>
                        </div>
                        <div class="goods-list">
                            <div class="box-wrapper h" v-if="store.live_apply_info.goods_list && store.live_apply_info.goods_list.length">
                                <img :src="store.live_apply_info.goods_list[0].goods_image_url" class="goods-image" />
                                <div class="box-wrapper v goods-wrapper">
                                    <div class="box-wrapper h goods-price">
                                        <span>直播价：</span>
                                        <span class="currency">$</span>
                                        <span class="price">{{store.live_apply_info.goods_list[0].goods_price}}</span>
                                    </div>
                                    <div class="goods-btn">点击查看</div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="live-btn-text">观看直播</div>
            </div>
            <!--直播end-->
            <mt-swipe class="mt-5" v-if="store.mb_sliders && store.mb_sliders.length" v-bind:style="getBannerStyle" :showIndicators="isShowIndicators">
                <mt-swipe-item v-for="(item, index) in store.mb_sliders" :key="index">
                    <img :style="getBannerStyle" v-lazy="item.imgUrl" @click="goAd(item)">
                </mt-swipe-item>
            </mt-swipe>
            <store-product-list
                    :items="rec_goods_list"
                    v-if="rec_goods_list && rec_goods_list.length > 0"
            ></store-product-list>
            <common-store-footer :store_id="store.store_id" v-if="showStoreSpecial.showSpecialFooter==1"></common-store-footer>
            
        </div>
		
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { Toast } from 'mint-ui'

import StoreSpecialIndex from '../storespecial/Index'
import CommonStoreHeader from '../common/CommonStoreHeader'
import CommonStoreFooter from '../common/CommonStoreFooter'
import { getStoreInfo } from '../../../api/homestoredetail'
import { getChatCount } from '../../../api/memberInstantMessage'
import StoreProductList from './StoreProductList'
import HeaderMore from '../../HeaderMore'
import { flowstat_record } from '../../../api/homestoredetail'
export default {
  name: 'Storedetail',
  data () {
    return {
      store: {
        store_id: this.$route.query.id ? this.$route.query.id : '',
        store_name: ''
      },
      rec_goods_list: false,
      popupVisible: false, // 弹出更多
      showDot: false,
    }
  },
  components: {
    HeaderMore,
    StoreProductList,
	CommonStoreHeader,
    CommonStoreFooter,
    StoreSpecialIndex
  },
  computed: {
    ...mapState({
      special: state => state.home.special,
      showStoreSpecial: state => state.home.showStoreSpecial,
      token: state => state.member.token,
      isOnline: state => state.member.isOnline
    }),
    getBannerStyle: function () {
      const { width } = window.screen
      let itemWidth = width
      let itemHeight = width * (1 / 4)
      return {
        width: itemWidth + 'px',
        height: itemHeight + 'px'
      }
    },
    isShowIndicators () {
      if (this.store.mb_sliders && this.store.mb_sliders.length > 1) {
        return true
      }
      return false
    }
  },
  created () {
  
    getStoreInfo(
      this.store.store_id, this.token
    ).then((res) => {
      this.store = res.result.store_info
      this.rec_goods_list = res.result.rec_goods_list
      if (this.store.is_platform_store) {
        this.fetchConfig({}).then(
          response => {
          },
          error => {
            Toast(error.message)
          }
        )
      }
    }).catch(function (error) {
		Toast(error.message)
    })
    flowstat_record(this.store.store_id,'','Store').then((res) => {
      })
    if (this.isOnline) {
      getChatCount().then(res => {
        if (res.result) {
          if (!this.showDot) {
            this.showDot = {}
          }
          this.showDot['chat'] = true
        }
      })
    }
  },
  methods: {
    ...mapActions({
      fetchConfig: 'fetchConfig'
    }),
    goLive (live_apply_id) {
      this.$router.push({ 'name': 'MemberLiveDetail', 'query': { 'live_apply_id': live_apply_id } })
    },
    goAd (item) {
      if (item.type === 2) {
        this.$router.push({ name: 'HomeGoodsdetail', query: { goods_id: item.link } })
      } else {
        window.location.href = item.link
      }
    },
    // 弹出更多
    popupMore () {
      if (!this.popupVisible) {
        this.popupVisible = true
      } else {
        this.popupVisible = false
      }
    }
  }

}
</script>

<style scoped lang="scss">
    

    .box-wrapper{box-sizing: border-box; display: flex;align-content: flex-start; flex-shrink: 0;}
    .box-wrapper.v{-webkit-box-orient: vertical; flex-direction: column; }
    .box-wrapper.h{-webkit-box-orient: horizontal; flex-direction: row;}
    .live-title{position: relative; display: block; font-size:$h2; width: 16rem; line-height: .75rem; font-weight: 700; text-overflow: ellipsis; white-space: nowrap; overflow: hidden;margin-bottom:.5rem;}
    .box-wrapper .live-desc{position: relative; height: .75rem; }
    .box-wrapper .live-count{position: absolute; display: block;  font-size:$fontSize;color:$subtitleTextColor; left: 0px; top: 0px; height: .75rem; margin-left: 2.76rem; line-height: .75rem; }
    .box-wrapper .live-icon{display: flex; width: 2.46rem; height: .75rem;}
    .box-wrapper .live-btn-text{position: relative; display: block;  font-size:$fontSize; color: rgb(255, 52, 103);}
    .box-wrapper .left{position: relative; width: 5.6rem; height: 5.6rem;}
    .box-wrapper .right{position: relative; flex: 1 1 0%; -webkit-box-flex: 1; margin-left: .5rem;}
    .box-wrapper .live-info{position: relative;  margin-bottom: .5rem;}
    .box-wrapper .live-image{position: relative;  height: 5.6rem; width: 5.6rem; border-radius: .3rem; overflow: hidden;background:#000}
    .box-wrapper .live-image img{width:100%;height: 100%}
    .box-wrapper .live-image video{width:100%;height: 100%}
    .box-wrapper.live-back-wrapper{position: absolute;  left: 0px; top: 0px; bottom:0;width: 100%; overflow: hidden;}
    .box-wrapper .live-back-image{display: flex; width: 100%; height: 100%; transform: scale(4); object-fit: cover;}
    .box-wrapper .live-back-cover{position: absolute;  left: 0px; top: 0px; right: 0px; bottom: 0px; background-color: rgba(255, 255, 255, 0.2);}
    .live-wrapper{position: relative;  width: 100%; padding: .6rem; overflow: hidden;box-sizing: border-box;display: flex;flex-direction: column;align-items: center;}
    .live-btn-text{position: relative;z-index: 2;background: $primaryGradualColor;color:#fff;height: 1.5rem;line-height: 1.5rem;border-radius: 1rem;text-align: center;width:10rem;font-size:$subFontSize;margin:.5rem auto 0 auto;}
    .goods-list{background: #f1f1f1;border-radius:.4rem;overflow: hidden;width:10rem;
        .goods-image{width:4rem;height: 4rem;}
        .goods-wrapper{flex:1;justify-content: center;align-items: center;
            .goods-price{font-size:$fontSize;align-items: center;margin-bottom:.5rem;font-weight: 700;
                .currency{color:$primaryColor}
                .price{color:$primaryColor;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    max-width: 3rem;}
            }
        }
        .goods-btn{border:1px solid $primaryColor;width:4rem;border-radius:1rem;height:1rem;line-height:1rem;color: $primaryColor;font-size:$fontSize;text-align: center;}
    }
</style>
